import React, { useRef } from "react";
import {
  CustomeDialog,
  CustomTable,
  InputControl,
  Loader,
  SelectChip,
  useStatusSelect,
  useTypeSelect,
} from "../../../shared";
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ArrowRight from "../../../assets/images/Icons/arrow_right.png";
import LeftArrow from "../../../assets/images/Icons/left_arrow.png";
import AddIcon from "@mui/icons-material/Add";
import AssignAndUnassignDialog from "./AssignAndUnassignDialog";

export default function StoreMappedRecipe({
  state,
  onSearchHandler,
  setState,
  onClearFilter,
  handleOpenDialog,
  assignRecipeToStore,
  handleAssignRecipeToStore,
  selectChipCategory,
  storeMappedRecipe,
  handleDeleteRecipeFromStore,
  recipeChipCategoryValuesHandler,
  storeMappedAllRecipe,
}) {
  const ref = useRef();

  const onScrollRefClick = (direction) => {
    const width = direction === "left" ? -250 : 250;
    ref.current.scrollLeft += width;
  };

  const onChangeTypeHandler = (value) => {
    setState((draft) => {
      draft.selectedType = value;
    });
  };
  const selectType = useTypeSelect({ onChangeTypeHandler });
  const onChangeStatusHandler = (value) => {
    setState((draft) => {
      draft.selectedStatus = value;
    });
  };
  const selectStatus = useStatusSelect({ onChangeStatusHandler });
  const columns = [
    {
      accessorKey: "recipe_name",
      header: () => "Recipe Name",
      cell: (props) => {
        const { row } = props;
        return !row.depth ? (
          <Typography
            sx={{
              color: "#1760D2",
              textTransform: "uppercase",
            }}
          >
            {row.original.recipe_name}
          </Typography>
        ) : (
          <Stack direction="row" gap="12px" alignItems="center">
            <Avatar
              src={
                row.original.image
                  ? row.original.image
                  : "/static/images/avatar/1.jpg"
              }
              variant="rounded"
              sx={{ width: 44, height: 44 }}
            />
            <span className="link-text">{row.original.recipe_name}</span>
          </Stack>
        );
      },
    },
    {
      accessorKey: "type",
      header: () => "Type",
      cell: (props) => {
        const { row } = props;
        return !row.depth
          ? ""
          : row.original.type === "finishedproduct"
          ? "Finished Product"
          : "Recipe";
      },
    },
    {
      id: "status",
      accessorKey: "status",
      header: () => "Status",
      cell: (props) => {
        const { row } = props;
        return row.depth ? (
          row.original.status ? (
            <Chip
              size="small"
              color="primary"
              variant="filled"
              label="ACTIVE"
            />
          ) : (
            <Chip size="small" color="gray" label="INACTIVE" />
          )
        ) : (
          ""
        );
      },
    },

    {
      id: "actions",
      cell: (props) => {
        const { row } = props;
        return row.depth ? (
          <Box gap={1}>
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                handleDeleteRecipeFromStore(row.original.id);
              }}
            >
              <img
                alt="delete"
                src="/icons/ic_trash_sm.png"
                style={{ width: "20px", height: "20px" }}
              />
            </IconButton>
            <IconButton>
              <img alt="details" src="/icons/arrow_forward.png" />
            </IconButton>
          </Box>
        ) : (
          ""
        );
      },
    },
  ];
  const sortingKey = [
    {
      id: "recipe_name",
      desc: false,
    },
  ];

  return (
    <>
      <CustomTable
        searchText={state.search}
        manualFiltering={true}
        defaultData={state?.recipeList ?? []}
        columns={columns}
        headerText="Recipes"
        subRow={"subRows"}
        allRowsExpanded={true}
        isLoading={state?.isLoading}
        onSearchChange={onSearchHandler}
        customRowStyle={(row) => {
          return !row.depth ? { borderBottom: "none" } : null;
        }}
        onRowLink={(e) => {
          return `/recipe/details/${e.id}/?basic-details`;
        }}
        tableHeaderStyles={{
          position: "sticky",
          top: "0px",
          zIndex: 99,
        }}
        tableStyle={{
          overflow: "unset",
          border: 1,
          borderRadius: "4px",
          borderColor: "divider",
        }}
        defaultSort={sortingKey}
        headerContentStyle={{ p: 0 }}
        isInTab
        tableHeaderContent={
          <Stack>
            <Stack
              direction="row"
              sx={{
                display: "flex",
                alignItems: "center",
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              {ref?.current?.scrollLeft > 0 ? (
                <Box
                  component={"img"}
                  height={20}
                  width={20}
                  src={LeftArrow}
                  onClick={() => onScrollRefClick("left")}
                  sx={{ cursor: "pointer" }}
                />
              ) : null}
              {state.search && (
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    borderRadius: "32px",
                    gap: "8px",
                    border: "1px solid #DFE8F2",
                    p: "6px 8px 6px 10px",
                    bgcolor: "#1760D2",
                    color: "#fff",
                    minWidth: "fit-content",
                  }}
                >
                  <Typography variant="subtitle2" fontWeight={500} noWrap>
                    {state.search}
                  </Typography>
                  <Chip
                    size="small"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      bgcolor: "#124da8",
                      color: "#fff",
                    }}
                    label={state?.recipeList?.length}
                  />
                </Stack>
              )}

              <Stack
                id="scroll-ele"
                ref={ref}
                sx={{
                  p: "6px",
                  flexDirection: "row",
                  gap: "6px",
                  overflow: "auto",
                  scrollBehavior: "smooth",
                }}
                className="scroll-hide"
              >
                {!selectChipCategory.isLoading &&
                selectChipCategory.chipCategory.chipCategoryOptions &&
                Array.isArray(
                  selectChipCategory.chipCategory.chipCategoryOptions
                ) ? (
                  selectChipCategory.chipCategory.chipCategoryOptions.map(
                    (v, i) => {
                      const isSelected = v.id === state?.chipCategoryId;
                      return (
                        <Stack
                          sx={{
                            flexDirection: "row",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            !state.search && recipeChipCategoryValuesHandler(v);
                          }}
                        >
                          <SelectChip
                            key={i}
                            value={v}
                            isSelected={isSelected}
                            countKey="recipeListCount"
                            isRecipeCount={false}
                          />
                        </Stack>
                      );
                    }
                  )
                ) : (
                  <Loader />
                )}
              </Stack>

              {ref?.current?.scrollWidth - ref?.current?.scrollLeft >
              ref?.current?.clientWidth ? (
                <Box
                  component="img"
                  height={20}
                  width={20}
                  src={ArrowRight}
                  onClick={() => onScrollRefClick("right")}
                  sx={{ cursor: "pointer" }}
                />
              ) : null}
            </Stack>

            <Stack
              sx={{
                flexDirection: "row",
                height: "52px",
                alignItems: "center",
                gap: "6px",
                px: "8px",
              }}
            >
              <InputControl
                fullWidth
                type="dropdown"
                variant="filter"
                size="small"
                options={selectType.typeOptions}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                sx={{
                  minWidth: "20%",
                  maxWidth: "30%",
                }}
                value={
                  selectType?.typeOptions?.find(
                    (option) => option.value === state.selectedType
                  ) || null
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Type" />
                )}
                onChange={(event, option) =>
                  selectType.typeValueChangeHandler(option)
                }
              />

              <InputControl
                type="dropdown"
                variant="filter"
                size="small"
                options={selectStatus.statusOptions}
                getOptionLabel={(option) => option?.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  minWidth: "150px",
                }}
                value={
                  selectStatus?.statusOptions?.find(
                    (option) => option.id === state.selectedStatus
                  ) || null
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Status" />
                )}
                onChange={(event, option) =>
                  selectStatus.statusValueChangeHandler(option)
                }
              />

              <Button
                type="button"
                size="small"
                variant="text"
                sx={{
                  p: "6px 12px 6px 12px",
                  gap: "6px",
                }}
                disabled={!state.selectedType && !state.selectedStatus}
                onClick={onClearFilter}
              >
                Clear All
              </Button>
            </Stack>
          </Stack>
        }
        rightContent={
          <Button
            sx={{
              height: "36px",
              borderColor: "divider",
              borderRadius: "10px",
              color: "#111C2B",
              bgcolor: "#F5F8FC",
            }}
            type="button"
            size="medium"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => handleOpenDialog(true)}
          >
            Recipe
          </Button>
        }
      />
      <CustomeDialog
        PaperProps={{
          sx: {
            minWidth: "60vw",
            maxHeight: "90vh",
          },
        }}
        sx={{ height: "90vh" }}
        isHeader={false}
        closeIcon={false}
        open={state.isDialogOpen}
        content={
          <AssignAndUnassignDialog
            handleCancel={handleOpenDialog}
            onAssign={handleOpenDialog}
            assignRecipeToStore={assignRecipeToStore}
            handleAssignRecipeToStore={handleAssignRecipeToStore}
            state={state}
            setState={setState}
            storeMappedRecipe={storeMappedRecipe}
            storeMappedAllRecipe={storeMappedAllRecipe}
          />
        }
      />
    </>
  );
}
